import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { positionsTabs } from './types'
import { useDefaultComponentTools } from '../../../../hooks/useDefaultComponentTools'
import { setPositionSearchString, setPositionsTab } from '../../../../store/redusers/positions/actions'
import {selectUserId} from '../../../../store/redusers/user/selectors'
import AppSearch from '../../../AppSearch'
import AppTabs from '../../../AppTabs'
import 'swiper/css'


const PositionsHeader = ({setHeaderHeight}) => {
	const {dispatch, mdUp, t} = useDefaultComponentTools()
	const isAuthorized = useSelector(selectUserId)
	const tabs = isAuthorized ? positionsTabs : [{id: 'news', label: 'News'}]
	const [activeTab, setActiveTab] = useState(tabs[0].id)
	const [headerWidth, setHeaderWidth] = useState(null)
	const getFilterData = (string) => {
		dispatch(setPositionSearchString(string))
	}
	const elementRef = useRef(null)

	useEffect(() => {
		const element = elementRef?.current
		if (!element) return
		const observer = new ResizeObserver(() => {
			setHeaderHeight(element.clientHeight)
			setHeaderWidth(element.clientWidth)
		})
		observer.observe(element)
		return () => {
			observer.disconnect()
		}
	}, [])

	useEffect(() => {
		dispatch(setPositionsTab(activeTab))
	}, [dispatch, activeTab])

	useEffect(() => {
		if(!isAuthorized) return
		dispatch(setPositionsTab(tabs[0].id))
	}, [isAuthorized])

	return (
		<Box ref={elementRef} sx={{
			display: 'flex', flexWrap: 'wrap',
			gap: mdUp ? '16px' : '8px',
			justifyContent: 'space-between'
		}}
		>
			<AppTabs
				sxCustom={{m: 0}} tabsArray={tabs}
				setActiveTab={setActiveTab}
				defaultActive={tabs[0].id} slider={835}
				parentWidth={headerWidth}
			/>
			<AppSearch
				placeholder={t('Search')+'...'}
				inputSx={{width: '268px'}}
				onUserInput={getFilterData}
			/>
		</Box>
	)
}

PositionsHeader.propTypes = {
	setHeaderHeight: PropTypes.func
}

export default PositionsHeader

